import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";

const CarHuddleInsuranceCustomerCare = ({contactUs}) => {
    const {data = []} = contactUs || {};
    return (
        <div styleName={"styles.outer"}>
            <p styleName={"styles.heading"}>Reach out to us for any queries</p>
            <div styleName={"styles.cardOuter"}>
                {data.map((item, index) => (
                    <a href={item.link} key={index}>
                        <img src={item.icon} />
                        {item.text}
                    </a>
                ))}
            </div>
        </div>
    );
};

CarHuddleInsuranceCustomerCare.propTypes = {
    contactUs: PropTypes.object
};

export default CarHuddleInsuranceCustomerCare;
